var map = {
	"./Discover.jpg": "5589",
	"./american.png": "6302",
	"./diners.png": "9d36",
	"./jcb2.png": "ce63",
	"./mastercard2.png": "5cb3",
	"./visa2.png": "9307"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b6d";